import ApiService from '@/services/api.service';

const PatientPortalMenuService = {
    getAll(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortalMenus/',
            headers: {},
            params: parameters
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientPortalMenus/${id}`);
    },

    add(data) {
        return ApiService.post(`/PatientPortalMenus`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientPortalMenus/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientPortalMenus/${id}`, data);
    }
};

export default PatientPortalMenuService;
